import request from '@/router/axios';

// 获取招商审核 列表
export const auditList = (current, size, params, search) => {
  return request({
    url: '/api/blade-loanInvestmentInfo/loanInvestmentInfo/audit-list',
    method: 'post',
    data: {
      ...params,
      ...search,
      current,
      size
    }
  })
}

// // 获取招商审核 详情
// export const auditDetail = (params) => {
//   return request({
//     url: '/api/blade-loanInvestmentInfo/loanInvestmentInfo/audit-detail',
//     method: 'post',
//     data: {
//       ...params,
//     }
//   })
// }

// 填写待注册账号
export const fillAccount = (params) => {
  return request({
    url: '/api/blade-loanInvestmentAccount/loanInvestmentAccount/fill',
    method: 'post',
    data: {
      ...params,
    }
  })
}

// 获取无分页版本的招商码，招商经理
export const getManagerCodeList = () => {
  return request({
    url: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/dropDown',
    method: 'get'
  })
}

// 获取账号类型 select下拉列表
export const getAccountTypeList = (rentType) => {
  return request({
    url: '/api/blade-loanInvestmentRolePost/loanInvestmentRolePost/getInvestmentRolePostList',
    method: 'get',
    params: {
      rentType
    }
  })
}